export default __webpack_public_path__ + "static/media/Final.21f7e667.mp4";